const projectHealthRatings = {
  excellent: { id: 'excellent', name: 'Excellent' },
  fair: { id: 'fair', name: 'Fair' },
  poor: { id: 'poor', name: 'Poor' },
};

export default projectHealthRatings;
